//import angular from 'angular';


angular.module('app.admin')
        .controller("currencySearchCtrl", [
            "$scope", "enums", "ocSecuritySvc", "amtXlatSvc", "currencySvc", "ocConfigSvc",
            function (
                $scope, enums, ocSecuritySvc, amtXlatSvc, currencySvc, ocConfigSvc
            ) {
                var vm = this;

                vm.processing = false;
                vm.status = enums.screenStatus.loading;
                vm.gridControl = {};
                vm.selectedItem = null;

                vm.svc = currencySvc;
                vm.config = ocConfigSvc;

                vm.criteria = {
                    filterValues: {
                        activeOptions: [],
                        currencyTypeIds: []
                    }
                };

                function init() {
                    vm.svc.loadDefaultsAsync().then(function () {

                        vm.defaultActiveStates = vm.svc.activeStates.filter(function (state) {
                            return state.default === true;
                        });

                        vm.status = enums.screenStatus.ready;
                    });
                }

                vm.onSelectedItemChanged = function (items) {
                    if (items != null && items.length === 1) {
                        vm.selectedItem = items[0];
                    } else {
                        vm.selectedItem = null;
                    }
                };

                vm.setHeaderHeight = function (height, offset) {
                    vm.gridTop = height + offset;
                };

                vm.export = function () {
                    vm.svc.export(vm.criteria);
                };

                vm.refreshGrid = function () {
                    vm.gridControl.refresh();
                };

                $scope.editItem = function (item) {
                    vm.svc.openItem(item, vm.refreshGrid);
                };

                $scope.addItem = function () {
                    vm.svc.addItem(vm.refreshGrid);
                };

                init();
            }
        ]
        )
